const STATS_SOURCES = {
  SDK: 'sdk', // Stats requested from the SDK API
  SDK_RAW: 'sdk_raw', // Stats requested from the SDK API, but raw stats
  WATCH_AUDIO_ACQUISITION: 'watch_audio_acquisition', // Stats requested for audio acquisition monitoring
  TEST_ONLY_GET_FRAMES_ENCODED: 'test_only_get_frames_encoded', // Stats requested for testing purposes only
  CONGESTION_LEVEL: 'congestion_level', // Stats requested for congestion level monitoring
  NETWORK_QUALITY: 'network_quality', // Stats requested for network quality monitoring
  SENDER_SIDE_STATS: 'sender_side_stats', // Stats requested for sender side stats monitoring
  MOS_SCORE: 'mos_score', // Stats requested for MOS score calculation
  QOS: 'qos', // Stats requested for Qos monitoring
  SUBSCRIBER_AUDIO_WATCHER: 'subscriber_audio_watcher', // Stats requested for subscriber audio monitoring
  SUBSCRIBER_VIDEO_WATCHER: 'subscriber_video_watcher', // Stats requested for subscriber video monitoring
  PUBLISHER_VIDEO_WATCHER: 'publisher_video_watcher', // Stats requested for publisher video monitoring
};

export default STATS_SOURCES;
